import { useState } from "react";
import { FileDown } from "lucide-react";
import { Button } from "./ui/button";
import api from "../lib/api";
import { toast } from "sonner";
import { t } from "../lib/i18n";

export const ImPdfButton = ({ companyId, companyName, variant = "outline", className = "" }) => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/companies/${companyId}/im/pdf`, { responseType: "blob", timeout: 90000 });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `IM_${(companyName || "Relevo").replace(/[^A-Za-z0-9_-]+/g, "_")}_Relevo.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 2000);
      toast.success(t("PDF del Information Memorandum descargado"));
    } catch (e) {
      let msg = "No se pudo generar el PDF";
      try { msg = JSON.parse(await e?.response?.data?.text())?.detail || msg; } catch { /* blob no JSON */ }
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  const base = variant === "light"
    ? "rounded-none h-10 px-5 bg-bone text-[#1E3A5F] hover:bg-white"
    : "rounded-none h-10 px-5 border-[#1E3A5F] text-[#1E3A5F] hover:bg-[#1E3A5F]/5";

  return (
    <Button
      onClick={download}
      disabled={busy}
      variant={variant === "light" ? "default" : "outline"}
      className={`${base} ${className}`}
      data-testid="im-download-pdf-btn"
    >
      <FileDown className={`w-3 h-3 mr-2 ${busy ? "animate-bounce" : ""}`} />
      {busy ? t("Generando PDF…") : t("Descargar IM en PDF")}
    </Button>
  );
};
